/**
 * // 扩展配置
 * _extend_config:
 * {
 *   loading:    // Loading配置
 *   error:      // error配置
 *   exception:  // exception配置
 * }
 */
import { showLoading, hideLoading } from "./loading.js";
import { handleError } from "./error.js"
import { handleException } from "./exception.js"

// 请求处理
export function handleRequest(requestHeaders)
{
  let config = requestHeaders._extend_config;
  // 显示Loading
  let configLoading = ((config && config.loading) ? config.loading : null);
  // showLoading(configLoading);
}

// 应答处理
export function handleResponse(requestHeaders, response)
{
  // let config = requestHeaders._extend_config;
  // 隐藏Loading
  // hideLoading();
  // 获取应答类型
  // let contentType = response.headers['Content-Type'];
  // if (contentType == undefined)
  //   contentType = response.headers['content-type'];
  // // 应答类型处理
  // if (contentType == undefined || contentType.toUpperCase().indexOf("JSON") < 0)
  //   return;
  // 错误处理
  // let configError = ((config && config.error) ? config.error : null);
  // handleError(response, configError);
  // handleError(response)
}

// 应答异常处理
export function handleResponseException(requestHeaders, response)
{
  let config = requestHeaders._extend_config;
  // 隐藏Loading
  // hideLoading();
  // 异常处理
  let configException = ((config && config.exception) ? config.exception : null);
  handleException(response, configException);
}
